import ServiceBase from '../../services/ServiceBase';
import taStrategyProxy from '../../proxies/strategy/TAStrategyProxy';

class TAStrategyService extends ServiceBase {
  fetchAccumulation(params, source) {
    return this.processSubscription(data => this.extractTickerChannels(data))(
      () =>
        this.applyMemoryCache('TAStrategyService.GetAccumulation', params)(() =>
          taStrategyProxy.getAccumulation(params, source),
        ),
    );
  }

  fetchBreakout(params, source) {
    return this.processSubscription(data => this.extractTickerChannels(data))(
      () =>
        this.applyMemoryCache('TAStrategyService.GetBreakout', params)(() =>
          taStrategyProxy.getBreakout(params, source),
        ),
    );
  }

  fetchBreakoutMa(params, source) {
    return this.processSubscription(data => this.extractTickerChannels(data))(
      () =>
        this.applyMemoryCache('TAStrategyService.GetBreakoutMa', params)(() =>
          taStrategyProxy.getBreakoutMa(params, source),
        ),
    );
  }

  fetchBestInDownTrend(params, source) {
    return this.processSubscription(data => this.extractTickerChannels(data))(
      () =>
        this.applyMemoryCache('TAStrategyService.GetBestInDownTrend', params)(
          () => taStrategyProxy.getBestInDownTrend(params, source),
        ),
    );
  }

  fetchMarketAnomaly(params, source) {
    return this.processSubscription(data => this.extractTickerChannels(data))(
      () =>
        this.applyMemoryCache('TAStrategyService.GetMarketAnomaly', params)(
          () => taStrategyProxy.getMarketAnomaly(params, source),
        ),
    );
  }
}
const taStrategyService = new TAStrategyService();
export default taStrategyService;
